// The underway item reads as the action being performed, e.g.
// "Send Application Review starting soon". The BE activity label arrives
// kind-prefixed ("Email - Application Review"); we strip that prefix down to
// the bare activity name and lead with a verb for the kind.

// All current automatable actions are "send"-style (email, review request,
// assessment invite, survey), so the default verb is "Send". Add an entry
// here only when a future kind needs a different verb.
const VERB_BY_KIND: Record<string, string> = {};

export const verbForKind = (kind: string | undefined): string =>
  (kind && VERB_BY_KIND[kind]) || 'Send';

// "Email - Application Review" → "Application Review". Splits on the first
// " - " (the kind/name separator the BE uses); returns the label unchanged
// when there's no separator.
export const stripActivityKindPrefix = (label: string): string => {
  const sep = label.indexOf(' - ');
  return sep >= 0 ? label.slice(sep + 3) : label;
};

// "email" + "Email - Application Review" → "Send Application Review".
export const getActivityActionLabel = (
  kind: string | undefined,
  label: string
): string => `${verbForKind(kind)} ${stripActivityKindPrefix(label)}`;
